import { Link } from "react-router-dom";
function Picture() {
    return (
        <div >
          <Link to='/'><img src="/assets/Group.jpeg" alt="St. Louis Brews"/></Link>
        </div>
    );
}

export default Picture;